import React from 'react';

const SubscriptionBanner = ({ plan, freeMinutesUsed = 0, freeMinutesRemaining = 0 }) => {
  const isFree = (plan || 'Free') === 'Free';
  const total = (Number(freeMinutesUsed) || 0) + (Number(freeMinutesRemaining) || 0);
  const pct = total > 0 ? Math.min(100, Math.round((freeMinutesUsed / total) * 100)) : 0;

  return (
    <div className="mi-sub-banner">
      <div className="mi-sub-info">
        <span className="mi-sub-plan">{plan || 'Free'} Plan</span>
        {isFree ? (
          <span className="mi-sub-text">
            {freeMinutesRemaining} min remaining · {freeMinutesUsed} min used
          </span>
        ) : (
          <span className="mi-sub-text">Unlimited interview minutes</span>
        )}
      </div>

      {isFree && (
        <div className="mi-sub-bar-wrap" title={`${pct}% used`}>
          <div className="mi-sub-bar-fill" style={{ width: `${pct}%` }} />
        </div>
      )}
    </div>
  );
};

export default SubscriptionBanner;
